import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import {CopyToClipboard} from "react-copy-to-clipboard"
import SVG from "react-inlinesvg"
import shareIcon from '@icons/share/default'

const ParentInviteLink = ({ group, hideDescription, callback, className, children }) => {
  const link = `${window.location.origin}/parent/invite?group_id=${group.object.id}`;

  const handleClick = (e) => {
    if (callback) { callback(e); }
    return true;
  }

  return (
    <Fragment>
      <CopyToClipboard text={link}>
        <a
          href="javascript:void(0)"
          onClick={handleClick}
          className={className || "btn btn--light-blue link--icon-left f--upper"}
        >
          { children ? children : (
              <Fragment>
                <SVG src={shareIcon} />
                { I18n.t("js.students_table.invite_link") }
              </Fragment>
            )
          }
        </a>
      </CopyToClipboard>

      { !!hideDescription ? null : (
          <p className="f--md mt-gutter-s">
            { I18n.t("js.students_table.invite.message") }
          </p>
        )
       }
    </Fragment>
  )
}

ParentInviteLink.propTypes = {
  hideDescription: PropTypes.bool,
  className: PropTypes.string
}

export default ParentInviteLink
